import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { PrismicRichTextType } from '../../components/richText/RichText';
import { SliceContainer } from '../../design/containers/sliceContainer/SliceContainer';
import { breakpointSmall } from '../../design/responsive/breakpoints';
import Spacing, { spacings } from '../../design/spacing/Spacing';
import Heading1 from '../../design/typography/Heading1';
import { BodyP } from '../../design/typography/Typography';
import { WithClassName } from '../../utlityTypes';

type TitleProps = {
  heading?: PrismicRichTextType;
  text?: string | '';
} & WithClassName;

const TitleContainer = styled.div`
  padding: ${spacings['32px']} 0;
  min-height: 400px;
  ${breakpointSmall(
    css`
      padding: ${spacings['100px']} 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    `
  )};
`;

const Container = styled(SliceContainer)`
  overflow: hidden;
`;
Container.defaultProps = { background: 'brand4GradientMidnightLogoLeft', borderRadius: '32px' };
/**
 * Renders Quote slice.
 */
const Title: FC<TitleProps> = ({ className, heading, text }) => {
  return (
    <Container className={className}>
      <TitleContainer>
        {heading && <Heading1>{heading}</Heading1>}
        <Spacing top="16px">
          <BodyP textAlign="center" type="bodyLRegular">
            {text}
          </BodyP>
        </Spacing>
      </TitleContainer>
    </Container>
  );
};
export default Title;
